<template>
  <div class="pc-video-detail">
    <section class="pc-container video-layout">
      <article class="video-main">
        <h1>{{ video.title }}</h1>
        <div class="player-wrap">
          <video
            v-if="video.videoUrl"
            :src="video.videoUrl"
            :poster="video.coverImage"
            controls
            preload="metadata"
          ></video>
          <div v-else class="video-placeholder">
            <img :src="video.coverImage" :alt="video.title">
            <button class="play-mask">▶</button>
          </div>
        </div>
        <div class="video-meta">
          <span class="meta-item clock">{{ displayTime }}</span>
          <span class="meta-item eye">{{ video.viewCount || 0 }}</span>
          <span class="meta-item like">0</span>
        </div>
      </article>

      <aside class="recommend-card">
        <h2>相关推荐</h2>
        <div class="recommend-list">
          <button v-for="item in recommendedVideos" :key="item.id" @click="goVideo(item)">
            <img :src="item.coverImage" :alt="item.title">
            <span class="recommend-info">
              <strong>{{ item.title }}</strong>
              <em class="meta-item eye">{{ item.viewCount || 0 }}</em>
            </span>
          </button>
        </div>
      </aside>
    </section>
  </div>
</template>

<script>
  import { getPcPublicVideoDetail, getPcPublicVideoList } from '@/api/pc'
  import commerce from '@/utils/pcCommerce'
  import { buildPcDetailPath, decodeRouteCode } from '@/utils/pcRouteCode'

  export default {
    name: 'PcVideoDetail',
    data() {
      return {
        video: commerce.normalizePcVideo({}),
        videoList: []
      }
    },
    computed: {
      displayTime() {
        const value = this.video.createdAt || this.video.updatedAt || ''
        if (!value) return ''
        return String(value).replace('T', ' ').slice(0, 19)
      },
      recommendedVideos() {
        return this.videoList
          .filter(item => String(item.id) !== String(this.video.id))
          .slice(0, 6)
      }
    },
    watch: {
      '$route.params.code': {
        immediate: true,
        handler() {
          this.loadDetail()
        }
      }
    },
    methods: {
      loadDetail() {
        const id = decodeRouteCode('video', this.$route.params.code)
        if (!id) {
          this.video = commerce.normalizePcVideo({})
          return
        }
        getPcPublicVideoDetail(id).then(data => {
          this.video = commerce.normalizePcVideo(data || {})
        }).catch(() => { this.video = commerce.normalizePcVideo({}) })
        getPcPublicVideoList({ page: 1, pageSize: 8 }).then(data => {
          const records = data && data.records ? data.records : []
          this.videoList = records.map(commerce.normalizePcVideo)
        }).catch(() => {
          this.videoList = []
        })
      },
      goVideo(item) {
        this.$router.push(buildPcDetailPath('video', item.id))
      }
    }
  }
</script>

<style scoped>
  .pc-video-detail {
    min-height: calc(100vh - 206px);
    padding: 12px 0 28px;
    background: #f1f3f8;
  }

  .video-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 346px;
    gap: 10px;
  }

  .video-main,
  .recommend-card {
    border-radius: 10px;
    background: #fff;
  }

  .video-main {
    min-height: 580px;
    padding: 18px 20px 24px;
  }

  .video-main h1 {
    margin: 0 0 28px;
    text-align: center;
    color: #111827;
    font-size: 22px;
    font-weight: 700;
    line-height: 28px;
  }

  .player-wrap {
    height: 440px;
    border-radius: 10px;
    overflow: hidden;
    background: #303030;
  }

  .player-wrap video,
  .video-placeholder {
    width: 100%;
    height: 100%;
  }

  .player-wrap video {
    display: block;
    object-fit: contain;
    background: #303030;
  }

  .video-placeholder {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .video-placeholder img {
    max-width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .play-mask {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 92px;
    height: 54px;
    margin: -27px 0 0 -46px;
    border: 1px solid rgba(255, 255, 255, .52);
    border-radius: 10px;
    background: rgba(17, 24, 39, .64);
    color: #fff;
    font-size: 28px;
    line-height: 54px;
    text-align: center;
  }

  .video-meta {
    height: 38px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 16px;
    color: #9ca3af;
    font-size: 14px;
  }

  .meta-item {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-style: normal;
    line-height: 18px;
  }

  .meta-item::before {
    display: inline-block;
    color: #b6beca;
    font-size: 15px;
    line-height: 1;
  }

  .clock::before {
    content: '◷';
  }

  .eye::before {
    content: '⊙';
  }

  .like::before {
    content: '♡';
  }

  .recommend-card {
    padding: 14px 16px 16px;
  }

  .recommend-card h2 {
    margin: 0;
    height: 34px;
    border-bottom: 1px solid #edf0f4;
    color: #111827;
    font-size: 16px;
    line-height: 24px;
  }

  .recommend-list {
    display: grid;
    gap: 14px;
    padding-top: 16px;
  }

  .recommend-list button {
    display: grid;
    grid-template-columns: 148px 1fr;
    gap: 8px;
    min-width: 0;
    padding: 0;
    border: 0;
    background: #fff;
    text-align: left;
    cursor: pointer;
  }

  .recommend-list img {
    width: 148px;
    height: 72px;
    border-radius: 5px;
    object-fit: cover;
    background: #f3f4f6;
  }

  .recommend-info {
    min-width: 0;
    padding-top: 2px;
  }

  .recommend-info strong {
    display: -webkit-box;
    color: #111827;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .recommend-info em {
    margin-top: 8px;
    color: #9ca3af;
    font-size: 13px;
  }
</style>
